import { ProjectInsights } from "@ecologi/shared";
import { fetchFromAPI } from "./fetch-from-api";

export const getProjectInsights = async (
  _,
  usernameOrId: string
): Promise<ProjectInsights.Payload> =>
  fetchFromAPI(`/project-insights/${usernameOrId}`);
